import currencyFormatter from 'currency-formatter';

const amountFormat = data => {
	if (data?.value) {
		const symbol = data?.currencyCode ? currencyFormatter.findCurrency(data?.currencyCode)?.symbol : null;
		return (
			(symbol || '') +
			parseFloat(data?.value?.toFixed(2))
				?.toString()
				?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		);
	} else {
		return '-';
	}
};

export default amountFormat;
